import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import LoadingSpinner from '../../../shared/components/LoadingSpinner';

// 대행(MANAGED) 계정에 열어줄 경로 — 사이드바에서 숨긴 메뉴는 URL로도 막아야 한다.
// 최종 차단은 서버가 하지만, 화면이 먼저 걸러야 빈 페이지를 보지 않는다.
const MANAGED_ALLOWED_PREFIXES = [
  '/producer/projects',
  '/producer/castings',   // 공고 수정 — 자기 공고만 (소유권은 서버가 검사)
  '/producer/settings',
  '/producer/password',   // 최초 비밀번호 변경
];

function PrivateRoute({ role }) {
  const { isLoggedIn, isTalent, isProducer, role: activeRole, isManagedAccount, accountLoaded, mustChangePassword } = useAuth();
  const { pathname } = useLocation();

  // AuthContext가 authReady = false이면 null을 반환하므로 여기까지 오면 authReady = true
  if (!isLoggedIn) return <Navigate to="/login" replace />;

  // 로그인 직후 대행 계정 여부를 아직 모른다. 이때 그리면 대행 계정이 일반 계정 화면으로
  // 보이고, 일반 대시보드로 보냈다가 공고 관리로 다시 튕긴다. 알 때까지 기다린다.
  if (!accountLoaded) {
    return (
      <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <LoadingSpinner size="md" />
      </div>
    );
  }

  // 최초 비밀번호를 바꾸기 전에는 어떤 화면으로도 우회 진입할 수 없다
  if (mustChangePassword && pathname !== '/producer/password') {
    return <Navigate to="/producer/password" replace />;
  }

  if (isManagedAccount && pathname.startsWith('/producer')) {
    const allowed = MANAGED_ALLOWED_PREFIXES.some(p => pathname.startsWith(p));
    if (!allowed) return <Navigate to="/producer/projects" replace />;
  }

  // 대행 계정은 대시보드가 없으므로 기본 착지점이 다르다
  const producerHome = isManagedAccount ? '/producer/projects' : '/producer/dashboard';

  if (role && activeRole !== role) {
    if (role === 'TALENT' && isTalent) return <Navigate to="/talent/dashboard" replace />;
    if (role === 'PRODUCER' && isProducer) return <Navigate to={producerHome} replace />;
    return <Navigate to={activeRole === 'TALENT' ? '/talent/dashboard' : producerHome} replace />;
  }

  return <Outlet />;
}

export default PrivateRoute;
